import React from "react"
import Image from "next/image"

const Card = () => {
  return (
    <div className="bg-white rounded-xl p-4 sm:p-6 lg:p-8 shadow-2xl w-full max-w-md sm:max-w-lg lg:max-w-xl">
      <div className="mb-6">
        <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4">
          <Image src="/building.svg" alt="Building" width={32} height={32} className="w-10 h-10 object-contain" />
        </div>
        <h2 className="text-xl sm:text-2xl lg:text-4xl text-teal-800 leading-tight">
          Fostering Positive <br />Change In The <br />Community
        </h2>
      </div>
      <div className="space-y-4 sm:space-y-4">
        <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginBottom: '20px' }} />
        <div className="flex gap-3 sm:gap-4">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center">
              <Image src="/setting.svg" alt="setting" width={32} height={32} className="w-13 h-13 object-contain" />
            </div>
          </div>
          <div className="flex-1">
            <h3 style={{ margin: '0' }} className="font-semibold text-gray-900 sm:mb-2 text-sm sm:text-base">
              Enhancing the Perimeter
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm leading-normal">
             GE Vernova will be making aesthetic enhancements to the perimeter of the site.
            </p>
          </div>
        </div>
        <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginBottom: '20px' }} />
        <div className="flex gap-3 sm:gap-4">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <Image src="/man.svg" alt="man" width={32} height={32} className="w-13 h-13 object-contain" />
            </div>
          </div>
          <div className="flex-1">
            <h3 style={{ margin: '0' }} className="font-semibold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">
              Honouring Community Memories
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm leading-normal">
              GE Vernova intends to commemorate the site’s history following the deconstruction process. GE Vernova will be seeking input from residents to share what the site and its history has meant to the community throughout the years.
            </p>
          </div>
        </div>
        <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginBottom: '20px' }} />
        <div className="flex gap-3 sm:gap-4">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center">
              <Image src="/book.svg" alt="book" width={32} height={32} className="w-13 h-13 object-contain" />
            </div>
          </div>
          <div className="flex-1">
            <h3 style={{ margin: '0' }} className="font-semibold text-gray-900  sm:mb-2 text-sm sm:text-base">
              Preserving the History of the Site in Peterborough
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm leading-normal">
              Several architecturally significant buildings will be retained on site, in accordance with the City’s designation of a portion of the property in February 2026. 
            </p>
          </div>
        </div>
        <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginBottom: '20px' }} />
        <div className="flex gap-3 sm:gap-4">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center">
              <Image src="/Checklist.svg" alt="checklist" width={32} height={32} className="w-13 h-13 object-contain" />
            </div>
          </div>
          <div className="flex-1">
            <h3 style={{ margin: '0' }} className="font-semibold text-gray-900  sm:mb-2 text-sm sm:text-base">
              Responsibly Managing the Site
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm leading-normal">
             GE Vernova will continue to work with the Ministry of Environment, Conservation and Parks to manage the site, and is committed to developing a deconstruction plan that minimizes disruptions to the neighbourhood and meets all applicable requirements.
            </p>
          </div>
        </div>
      </div>
      <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginTop: '10px' }} />
      <div className="mb-4"></div>
    </div>
  )
}

export default Card;
